export default "__VITE_ASSET__DriBNlPl__"